import React from 'react';
import { servicesData } from './ServicesData';
import ServiceCard from './ServiceCard';

const ServiceGrid = () => {
  return (
    <div className="border-t border-white/10">
      {servicesData.map((service, index) => (
        <ServiceCard key={service.title} {...service} index={index} />
      ))}
    </div>
  );
};

export default ServiceGrid;
